import { render } from "./AvatarUpload.vue?vue&type=template&id=e52f561e&ts=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=ts"
export * from "./AvatarUpload.vue?vue&type=script&lang=ts"

import "./AvatarUpload.vue?vue&type=style&index=0&id=e52f561e&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__